import React from 'react';
import PageKit from '../PageKit';
import TitleBanner from '../component/TitleBanner';
import { useTranslation } from 'react-i18next';

function NotFound() {
  const { t } = useTranslation();
  return (
    <PageKit>
      <div className="global-background">
        <TitleBanner
          imageSrc={`${process.env.PUBLIC_URL}/img/banners/geometricbannerreversed5.png`}
          title={t('NotFound.Title')}
          height='40vh'
          textColor="242F38"
          withShadow={false}
        />
        <div style={{display:'grid', placeItems:'center', padding:'24px'}}>
          <p style={{maxWidth: 720, textAlign: 'center', color: '#475569', fontSize: 18}}>
            {t('NotFound.Description')}
          </p>
          <a href="/" style={{
            marginTop: 14,
            display: 'inline-block',
            background: '#D6AE49',
            color: '#fff',
            padding: '12px 18px',
            borderRadius: 999,
            fontWeight: 600,
            textDecoration: 'none',
            boxShadow: '0 6px 18px rgba(214, 174, 73, 0.35)'
          }}>{t('NotFound.BackHome')}</a>
        </div>
      </div>
    </PageKit>
  );
}

export default NotFound;
